import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "videos-page" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "sidebar" }
const _hoisted_4 = { class: "nav-card" }
const _hoisted_5 = { class: "nav-logo" }
const _hoisted_6 = { class: "logo-icon" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "nav-list" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  class: "nav-menu-visual",
  "aria-hidden": "true"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "page-shell" }
const _hoisted_13 = { class: "video-sticky-controls" }
const _hoisted_14 = { class: "search-section" }
const _hoisted_15 = { class: "search-box" }
const _hoisted_16 = { class: "filters-section" }
const _hoisted_17 = ["data-filter-id", "onClick"]
const _hoisted_18 = { class: "video-grid" }
const _hoisted_19 = { class: "video-cover" }
const _hoisted_20 = { class: "cover-frame video-skeleton-cover" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "video-cover" }
const _hoisted_23 = { class: "cover-frame" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "video-title" }
const _hoisted_26 = { class: "video-season" }
const _hoisted_27 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "sheet-check"
}

import logo2Image from '../assets/logo2.png'
import menuBgImage from '../assets/menu_bg.jpg'
import ParentPasswordModal from '../components/ParentPasswordModal.vue'
import { nextTick, onMounted, onUnmounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getVideoSeriesPage, type VideoSeries } from '@/api/course-video'
import { getDictDataList } from '@/api/dict'

const videoSkeletonCount = 8

export default /*@__PURE__*/_defineComponent({
  __name: 'videos',
  setup(__props) {

const route = useRoute()
const routeStage = Array.isArray(route.query.stage) ? route.query.stage[0] : route.query.stage
const hasRouteStage = routeStage != null && routeStage !== ''

const queryParams = ref({
  pageNo: 1,
  pageSize: 100,
  stage: routeStage,
  keyword: undefined as string | undefined,
  category: undefined as string | undefined,
})

const searchKeyword = ref('')
const activeFilter = ref('all')
const activeNav = ref('')
const isFilterMenuOpen = ref(false)
const selectedVideoId = ref(null)
const filtersMainRef = ref(null)
const isTopbarScrolled = ref(false)
const isVideoListLoading = ref(false)
const router = useRouter()
const parentPasswordModalRef = ref(null)

const navItems = [
  { id: 'home', label: '首页', icon: 'home' },
  { id: 'history', label: '观看历史', icon: 'play-circle' },
  { id: 'favorites', label: '宝贝收藏', icon: 'heart' },
  { id: 'settings', label: '偏好设置', icon: 'cog' },
  { id: 'parent', label: '家长模式', icon: 'user-shield' },
]


const categoryList = ref<any>([])
const videos = ref<VideoSeries[]>([])
const stageFilterList = [
  { id: 'stage-1', value: '1', label: '0-3', type: 'stage' },
  { id: 'stage-2', value: '2', label: '3-6', type: 'stage' },
  { id: 'stage-3', value: '3', label: '6-9', type: 'stage' },
  { id: 'stage-4', value: '4', label: '9-12', type: 'stage' },
]

const syncFilterChipIntoView = () => {
  nextTick(() => {
    const container = filtersMainRef.value
    if (!container) {
      return
    }

    const activeChip = container.querySelector(
      `button[data-filter-id="${activeFilter.value}"]`
    )
    if (!activeChip) {
      return
    }

    activeChip.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    })
  })
}

const selectFilter = (filterId, filterValue, filterType = 'category') => {
  activeFilter.value = filterId
  queryParams.value.pageNo = 1

  if (filterType === 'stage') {
    queryParams.value.stage = filterValue
    queryParams.value.category = undefined
  } else {
    queryParams.value.stage = routeStage
    queryParams.value.category = filterValue || undefined
  }

  getVideoList()
  syncFilterChipIntoView()
}

const toggleMoreFilters = () => {
  isFilterMenuOpen.value = !isFilterMenuOpen.value
}

const closeFilterMenu = () => {
  isFilterMenuOpen.value = false
}

const selectFilterFromMenu = (filterId, filterValue, filterType = 'category') => {
  selectFilter(filterId, filterValue, filterType)
  closeFilterMenu()
}

const handleGoBack = () => {
  if (window.history.length > 1) {
    router.back()
    return
  }

  router.push('/category')
}

const openParentPasswordModal = () => {
  parentPasswordModalRef.value?.open()
}

const handleNavItemClick = (item) => {
  if (item.id === 'home') {
    router.push('/')
    return
  }

  if (item.id === 'parent') {
    openParentPasswordModal()
    return
  }

  if (item.id === 'settings') {
    router.push('/preference')
    return
  }

  if (item.id === 'history' || item.id === 'favorites') {
    router.push({
      path: '/history',
      query: item.id === 'favorites' ? { tab: 'favorites' } : {}
    })
  }
}

const handlePageScroll = () => {
  isTopbarScrolled.value = window.scrollY > 12
}

const handleSearch = () => {
  queryParams.value.pageNo = 1
  queryParams.value.keyword = searchKeyword.value || undefined
  getVideoList()
}

const handleVideoClick = (video) => {
  selectedVideoId.value = video.id
  router.push({path: '/player', query: {seriesId: video.id}})
}

onMounted(() => {
  getCategoryList()
  getVideoList()
  window.addEventListener('scroll', handlePageScroll, { passive: true })
  handlePageScroll()
})

onUnmounted(() => {
  window.removeEventListener('scroll', handlePageScroll)
})

const getVideoList = async () => {
  isVideoListLoading.value = true
  try {
    const data = await getVideoSeriesPage(queryParams.value)
    videos.value = data?.list || []
    //total.value = data.total
  } catch {
    videos.value = []
  } finally {
    isVideoListLoading.value = false
  }
}

const getCategoryList = async () => {
  try {
    const data = await getDictDataList('course_video_category')
    categoryList.value = [
      { id: 'all', value: '', label: '全部', type: 'category' },
      ...(!hasRouteStage ? stageFilterList : []),
      ...(data || [])
    ]
  } catch {

  }
}


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "bg-decoration" }, [
      _createElementVNode("div", { class: "orb orb-1" }),
      _createElementVNode("div", { class: "orb orb-2" }),
      _createElementVNode("div", { class: "orb orb-3" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("aside", _hoisted_3, [
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _unref(logo2Image),
                alt: "",
                class: "logo2-icon"
              }, null, 8, _hoisted_7)
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "brand-copy" }, [
              _createElementVNode("h1", { class: "brand-name" }, "树苗英语"),
              _createElementVNode("span", { class: "brand-subtitle" }, "TREE SAPLING")
            ], -1))
          ]),
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
              return _createElementVNode("li", {
                key: item.id
              }, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _withModifiers(($event: any) => (handleNavItemClick(item)), ["prevent"]),
                  class: _normalizeClass(['nav-item', { active: activeNav.value === item.id }])
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: item.icon,
                    class: "nav-icon"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", null, _toDisplayString(item.label), 1)
                ], 10, _hoisted_9)
              ])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              src: _unref(menuBgImage),
              alt: "",
              class: "nav-menu-image"
            }, null, 8, _hoisted_11)
          ])
        ])
      ]),
      _createElementVNode("main", _hoisted_12, [
        _createElementVNode("div", {
          class: _normalizeClass(["mobile-topbar", { 'is-scrolled': isTopbarScrolled.value }])
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "mobile-back-btn",
            onClick: handleGoBack,
            "aria-label": "返回上一页"
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "chevron-left" })
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "mobile-topbar-title" }, "视频", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("span", {
            class: "mobile-topbar-spacer",
            "aria-hidden": "true"
          }, null, -1))
        ], 2),
        _cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "mobile-topbar-offset",
          "aria-hidden": "true"
        }, null, -1)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("section", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_font_awesome_icon, {
                icon: "search",
                class: "search-icon"
              }),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKeyword).value = $event)),
                type: "text",
                class: "search-input",
                placeholder: "请输入关键字搜索",
                "aria-label": "搜索视频",
                onKeyup: _withKeys(handleSearch, ["enter"])
              }, null, 544), [
                [
                  _vModelText,
                  searchKeyword.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "search-button",
                "aria-label": "搜索",
                title: "搜索",
                onClick: handleSearch
              }, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("span", null, "搜索", -1)
              ]))])
            ])
          ]),
          _createElementVNode("section", _hoisted_16, [
            _createElementVNode("div", {
              ref_key: "filtersMainRef",
              ref: filtersMainRef,
              class: "filters-main"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, (category) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: category.id,
                  type: "button",
                  class: _normalizeClass(["filter-chip", { active: activeFilter.value === category.id }]),
                  "data-filter-id": category.id,
                  onClick: ($event: any) => (selectFilter(category.id, category.value, category.type))
                }, _toDisplayString(category.label), 11, _hoisted_17))
              }), 128))
            ], 512),
            _createElementVNode("button", {
              type: "button",
              class: "toggle-btn",
              onClick: toggleMoreFilters
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "chevron-down",
                class: _normalizeClass({ expanded: isFilterMenuOpen.value })
              }, null, 8, ["class"])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_18, [
          (isVideoListLoading.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(videoSkeletonCount, (index) => {
                return _createElementVNode("article", {
                  key: `video-skeleton-${index}`,
                  class: "video-card video-skeleton-card",
                  "aria-hidden": "true"
                }, [
                  _createVNode(_component_el_skeleton, { animated: "" }, {
                    template: _withCtx(() => [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_el_skeleton_item, {
                            variant: "circle",
                            class: "video-skeleton-cover-inner"
                          })
                        ])
                      ]),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        class: "video-skeleton-title"
                      }),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        class: "video-skeleton-season"
                      })
                    ]),
                    _: 1
                  })
                ])
              }), 64))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(videos.value, (video) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: video.id,
                  class: _normalizeClass(["video-card", { selected: selectedVideoId.value === video.id }]),
                  onClick: ($event: any) => (handleVideoClick(video))
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("img", {
                        src: video.coverUrl,
                        alt: "",
                        class: "cover-image"
                      }, null, 8, _hoisted_24)
                    ])
                  ]),
                  _createElementVNode("h3", _hoisted_25, _toDisplayString(video.name), 1),
                  _createElementVNode("p", _hoisted_26, "共" + _toDisplayString(video.totalSeason) + "季", 1)
                ], 10, _hoisted_21))
              }), 128)),
          (!isVideoListLoading.value && videos.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("p", { class: "empty-title" }, "没有找到匹配的视频", -1),
                _createElementVNode("p", { class: "empty-desc" }, "试试更换关键词或分类筛选", -1)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "sheet-fade" }, {
      default: _withCtx(() => [
        (isFilterMenuOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "sheet-mask",
              onClick: closeFilterMenu
            }, [
              _createElementVNode("section", {
                class: "sheet-panel",
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "sheet-handle" }, null, -1)),
                _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "sheet-title" }, "选择更多筛选", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, (filter) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: filter.id,
                    type: "button",
                    class: _normalizeClass(["sheet-option", { active: activeFilter.value === filter.id }]),
                    style: _normalizeStyle({ '--filter-color': filter.color }),
                    onClick: ($event: any) => (selectFilterFromMenu(filter.id, filter.value, filter.type))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(filter.label), 1),
                    (activeFilter.value === filter.id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, "已选"))
                      : _createCommentVNode("", true)
                  ], 14, _hoisted_28))
                }), 128)),
                _createElementVNode("button", {
                  type: "button",
                  class: "sheet-cancel",
                  onClick: closeFilterMenu
                }, "取消")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(ParentPasswordModal, {
      ref_key: "parentPasswordModalRef",
      ref: parentPasswordModalRef
    }, null, 512)
  ]))
}
}

})